import date from 'date-and-time'
import config from 'Config'
import de from 'date-and-time/locale/de'
import en from 'date-and-time/locale/en'

export const formatDate = dateString => {
  date.locale(config.locale ? de : en)
  return date.format(new Date(dateString), 'MMMM DD YYYY')
}
